import { createContext, useContext, type ReactNode } from "react";

interface AuthState {
  isAuthenticated: boolean;
  signInUrl: string;
}

const AuthCtx = createContext<AuthState>({
  isAuthenticated: false,
  signInUrl: import.meta.env.VITE_MARKETING_URL
    ? `${import.meta.env.VITE_MARKETING_URL}/signin`
    : "http://localhost:3011/signin",
});

export function AuthProvider({ children }: { children: ReactNode }) {
  // Cookie-based auth is set by marketing; portal checks presence only for now.
  const hasToken = /(?:^|; )inv_access=/.test(document.cookie);
  const signInUrl = import.meta.env.VITE_MARKETING_URL
    ? `${import.meta.env.VITE_MARKETING_URL}/signin`
    : "http://localhost:3011/signin";

  return (
    <AuthCtx.Provider value={{ isAuthenticated: hasToken, signInUrl }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}